<template>
  <div class="download1">
    <div class="head">
      <div class="imgBox">
        <img src="@/assets/images/logo/logo@2x.png" alt="" />
      </div>
    </div>
    <div class="content">
      <p class="show">全新版本，更多套餐优惠活动都在这里！</p>
      <ul class="downloadList">
        <li
          @mouseleave="item.shadow = false"
          @mousemove="handleShow(index)"
          v-for="(item, index) in downloadList"
          :key="index"
          :style="{
            boxShadow: item.shadow
              ? '0px 0px 14px 0px rgba(142, 120, 120, 0.25)'
              : 'none',
          }"
          class="item"
        >
          <p class="version">V {{ item.version }}</p>
          <el-popover
            @show="handleShow(index)"
            :disabled="item.label === '金源药业桌面端'"
            popper-class="downloadPopper"
            placement="top"
            width="210"
            trigger="hover"
          >
            <img
              class="downloadimg"
              src="@/assets/images/logo/app_ewm.png"
              alt=""
            />
            <div class="box" slot="reference">
              <img :src="require('@/assets/images/' + item.icon)" alt="" />
              <p class="name">{{ item.label }}</p>
              <p class="date">更新日期: {{ item.date }}</p>
              <div class="btn" @click="download(item)">
                <img src="@/assets/images/icon_xz@2x.png" alt="" />
                <span class="text">立即下载</span>
              </div>
            </div>
          </el-popover>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.getDownload();
  },
  mounted() {
    document.title = "软件下载";
  },
  data() {
    return {
      downloadList: [
        {
          shadow: false,
          url: "",
          show: false,
          version: "1.2.0",
          icon: "icon_pc@2x.png",
          label: "金源药业桌面端",
          date: "2021.12.17",
        },
        {
          shadow: false,
          url: "",
          version: "1.2.0",
          icon: "icon_az@2x.png",
          label: "金源药业Android版",
          date: "2021.12.17",
        },
        {
          shadow: false,
          url: "",
          version: "1.2.0",
          icon: "icon_ios@2x.png",
          label: "金源药业iPhone版",
          date: "2021.12.17",
        },
      ],
    };
  },
  methods: {
    download(item) {
      window.location.href = item.url;
    },
    getDownload() {
      this.$api.GET_APPCURRENT().then((res) => {
        console.log(res);
        let data = res.data;
        this.downloadList[0].version = data[2].version;
        this.downloadList[1].version = data[0].version;
        this.downloadList[2].version = data[1].version;
        this.downloadList[0].date = data[2].updateDate.slice(0, 11);
        this.downloadList[1].date = data[0].updateDate.slice(0, 11);
        this.downloadList[2].date = data[1].updateDate.slice(0, 11);
        this.downloadList[0].url = data[2].url;
        this.downloadList[1].url = data[0].url;
        this.downloadList[2].url = data[1].url;
      });
    },
    move() {
      console.log("move");
    },
    handleShow(index) {
      this.downloadList.forEach((item) => {
        item.shadow = false;
      });
      this.downloadList[index].shadow = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.download1 {
  min-height: calc(100% - 110px);
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f8f8f8;
  .downloadimg {
    width: 180px;
    height: 180px;
  }
  .head {
    display: flex;
    justify-content: center;
    width: 100%;
    background-color: #ffffff;
    padding: 14px 0px;
    .imgBox {
      min-width: 1000px;
      max-width: 1000px;
      img {
        width: 174px;
        height: 60px;
      }
    }
  }
  .content {
    padding-top: 70px;
    padding-bottom: 88px;
    min-width: 1000px;
    max-width: 1000px;
    .show {
      font-size: 28px;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      text-align: CENTER;
      color: #333333;
      letter-spacing: 0px;
    }
    .downloadList {
      justify-content: space-around;
      margin-top: 67px;
      display: flex;
      .item:hover {
        box-shadow: 0px 0px 14px 0px rgba(142, 120, 120, 0.25);
      }
      .item {
        transition: all 0.5s;
        cursor: pointer;
        padding: 14px 14px 0px 14px;
        width: 320px;
        height: 430px;
        background: #ffffff;
        border-radius: 4px;
        .version {
          text-align: right;
          font-size: 14px;
          font-family: Microsoft YaHei, Microsoft YaHei-Regular;
          font-weight: 400;
          color: #b2b2b2;
          letter-spacing: 0px;
        }
        .box {
          margin: 50px auto 0px auto;
          width: 180px;
          // margin-top: 50px;
          // width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          img {
            width: 74px;
            height: 74px;
          }
          .name {
            margin-top: 30px;
            font-size: 16px;
            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
            font-weight: 400;
            text-align: CENTER;
            color: #404040;
            letter-spacing: 0px;
          }
          .date {
            font-size: 13px;
            font-family: Microsoft YaHei, Microsoft YaHei-Regular;
            font-weight: 400;
            text-align: CENTER;
            color: #999999;
            letter-spacing: 0px;
            margin-top: 8px;
          }
          .btn {
            cursor: pointer;
            justify-content: center;
            align-items: center;
            margin-top: 80px;
            display: flex;
            width: 180px;
            height: 36px;
            background: #ff4b4b;
            img {
              width: 18px;
              height: 18px;
            }
            .text {
              margin-left: 6px;
              font-size: 14px;
              font-family: Microsoft YaHei, Microsoft YaHei-Regular;
              font-weight: 400;
              text-align: CENTER;
              color: #ffffff;
              letter-spacing: 0px;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/download/download.vue